<template>
  <OrganismAccordion v-if="trainings" :list="groupedData" />
</template>

<script>
import OrganismAccordion from '../../../organisms/fitness/group-training/OrganismAccordion'

export default {
  name: 'TemplateAccordion',
  components: {
    OrganismAccordion,
  },
  props: {
    trainings: {
      type: Array,
      required: true,
    },
  },
  computed: {
    groupedData() {
      if (!Array.isArray(this.trainings)) return []

      const uniqueTrainings = new Map()

      this.trainings.forEach(item => {
        const trainingName = item.name || ''
        if (uniqueTrainings.has(trainingName)) {
          const existing = uniqueTrainings.get(trainingName)
          if (item.club && !existing.clubs.some(c => c.id === item.club.id)) {
            existing.clubs.push(item.club)
          }
        } else {
          uniqueTrainings.set(trainingName, {
            ...item,
            clubs: item.club ? [item.club] : [],
          })
        }
      })

      const directionsSet = new Map()
      uniqueTrainings.forEach(item => {
        const directionField = item.custom_fields?.find(
          f => ['power', 'energy', 'balance'].includes(f.alias) && f.key?.value === '1',
        )
        if (directionField) {
          item.direction = directionField.alias
          if (!directionsSet.has(item.direction)) {
            directionsSet.set(item.direction, [])
          }
          directionsSet.get(item.direction).push(item)
        }
      })
      const grouped = Object.fromEntries(directionsSet)
      const categoryNames = {
        power: { title: 'POWER', sup: '(рельеф и сила)' },
        energy: { title: 'ENERGY', sup: '(тонус и выносливость)' },
        balance: { title: 'BALANCE', sup: '(контроль над телом и разумом)' },
      }
      const result = Object.entries(grouped).map(([direction, items]) => {
        const sortedItems = [...items].sort((a, b) => (a.name || '').localeCompare(b.name || '', 'ru'))
        const list = sortedItems.map(item => ({
          label: item.name || '',
          image: item.image || `/uploads/${item.name}.webp`,
          progress:
            item.custom_fields
              ?.filter(
                field =>
                  field.key?.value && field.key.value !== '' && !['power', 'energy', 'balance'].includes(field.alias),
              )
              ?.map(field => ({
                title: field.name,
                progress: field.key.value,
              })) || [],
          text: {
            title: 'О программе',
            text: item.description || '',
          },
          footer: [
            {
              title: 'Расписание в клубах',
              controls: item.clubs.map(club => ({
                title: club.title,
                to: `/timetable/${club.slug}/adult`,
              })),
            },
          ],
          tags: [
            {
              title: 'Направления',
              controls: [{ title: direction }],
            },
          ],
        }))

        return {
          title: categoryNames[direction]?.title || direction.toUpperCase(),
          sup: categoryNames[direction]?.sup || '',
          list,
        }
      })

      const priorityOrder = { power: 1, energy: 2, balance: 3 }
      result.sort((a, b) => {
        const aDirection = Object.keys(grouped).find(
          key => categoryNames[key]?.title === a.title || key.toUpperCase() === a.title,
        )
        const bDirection = Object.keys(grouped).find(
          key => categoryNames[key]?.title === b.title || key.toUpperCase() === b.title,
        )
        return (priorityOrder[aDirection] || 999) - (priorityOrder[bDirection] || 999)
      })
      return result
    },
  },
}
</script>
